import { createCardComponent } from "./Card";
export var Card = createCardComponent({
  interactive: false,
  name: 'Card',
  tag: 'div'
});
export var LinkCard = createCardComponent({
  // Remove styles inherited from <a>
  additionalStyles: {
    color: 'unset',
    textDecoration: 'unset'
  },
  interactive: true,
  name: 'LinkCard',
  tag: 'a'
});
export * from "./interfaces";